import { useLayoutEffect, useRef, useState } from "react";

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "src/core/components/ui/tooltip";

export const TruncatedTextTooltip = ({ children }: { children: React.ReactNode }) => {
  const ref = useRef<HTMLDivElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;

    const checkTruncation = () => {
      const truncated = el.scrollHeight > el.clientHeight;
      setIsTruncated(truncated);
    };

    checkTruncation();

    // Recalcule aussi quand la largeur change
    window.addEventListener("resize", checkTruncation);
    return () => window.removeEventListener("resize", checkTruncation);
  }, [children]);

  const content = (
    <div
      ref={ref}
      className="flex-1 ml-10 min-w-0 overflow-hidden break-words"
      style={{
        display: "-webkit-box",
        WebkitLineClamp: 2,
        WebkitBoxOrient: "vertical",
        wordBreak: "break-word",
      }}
    >
      {children}
    </div>
  );

  if (!isTruncated) {
    return content;
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>{content}</TooltipTrigger>
        <TooltipContent
          side="bottom"
          align="start"
          className="max-w-md whitespace-normal break-words"
        >
          {children}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
